import _ from 'lodash';
import * as ActionType from '../actions/actionType';

const innitialState = {
};

const receivedContent = (state, action) => {
  const content = _.get(action, 'content');
  return [...content];
};

export default (state = innitialState, action) => {
  switch (action.type) {
    case ActionType.INIT_NEWS_EVENT:
      // return receivedContent(state, action);
      return {
        ...state,
        en: receivedContent(state, action),
      };
    case ActionType.INIT_NEWS_EVENT_TH:
      return {
        ...state,
        th: receivedContent(state, action),
      };
    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/reducers/newsEvent.js